module.exports = __webpack_public_path__ + "media/images/eu_flag_yellow-2ff18e8a0928c0c05f315b9188a1f886.jpg";